import React from "react";
import { useStaticQuery, graphql } from "gatsby";

import config from "../../clhbid-config";

const SEO: React.FC<{
  title: string;
  description: string;
  url: string;
  index?: boolean;
  image?: string;
  children?: React.ReactNode;
}> = ({ description, url, index = true, children, ...props }) => {
  const {
    defaultImage: {
      childImageSharp: { gatsbyImageData: defaultImage },
    },
  } = useStaticQuery<Queries.SEOQuery>(query);

  const title = `${props.title} | CLHbid.com`;

  const image =
    props.image ||
    `${config.PRODUCTION_SITE_URL}${defaultImage.images.fallback.src}`;

  return (
    <>
      <title>{title}</title>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no, minimum-scale=1"
      />
      <meta
        name="robots"
        content={
          config.GATSBY_ENV === "production" && index
            ? "index, follow"
            : "noindex, nofollow"
        }
      />
      <meta
        name="facebook-domain-verification"
        content="958bwgar9ujam4t89ctw5qn1i4i4hy"
      />
      <meta name="description" content={description} />
      <meta name="og:title" content={title} />
      <meta name="og:image" content={image} />
      <meta name="og:type" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content="@clhbid" />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="canonical" href={`${config.PRODUCTION_SITE_URL}${url}`} />
      {children}
    </>
  );
};

const query = graphql`
  query SEO {
    defaultImage: file(relativePath: { eq: "default-seo-meta-image.jpg" }) {
      childImageSharp {
        gatsbyImageData(
          width: 1200
          height: 630
          quality: 90
          placeholder: NONE
          layout: FIXED
        )
      }
    }
  }
`;

export default SEO;
